import React, { useState, useEffect, useRef } from "react";
import { Link } from 'react-router-dom';
import { Col, Row, Card, Container, Breadcrumb, Table, Modal, Form } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { Calendar } from 'primereact/calendar';
import { Button } from 'primereact/button';
import { ProgressSpinner } from 'primereact/progressspinner';
import config from '../../config';
import { useClientAuth } from '../../context/ClientAuthContext';
import GifLoder from '../../components/GifLoder';
import { Badge } from 'primereact/badge';
import CustomToast from '../../components/CustomToast';
import { Tooltip } from 'primereact/tooltip';
function Client_home() {
    const { role, ClientId, apiRequest } = useClientAuth();
    const [loading, setLoading] = useState(true);
    // Scoped, lightweight loading flag for background refreshes (e.g. month filter)
    // so we don't unmount/blank the whole page like `loading` does.
    const [isFilterLoading, setIsFilterLoading] = useState(false);
    const isInitialLoadRef = useRef(true);
    const [visibleRight, setVisibleRight] = useState(false);
    const [formsData, setFormsData] = useState([]);
    const [transition, setTransition] = useState(''); // Manage transition state
    const navigate = useNavigate();
    const toastRef = useRef(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [currentForm, setCurrentForm] = useState(null);
    const [updatedResponses, setUpdatedResponses] = useState([]);

    const showMessage = (severity, detail) => {
        const summary = severity.charAt(0).toUpperCase() + severity.slice(1);
        toastRef.current.show(severity, summary, detail);
    };

    const handleNavigation = (path, animationClass) => {
        setTransition(animationClass); // Set the animation class
        setTimeout(() => {
            navigate(path); // Navigate after animation
            setTransition(''); // Reset transition state
        }, 800); // Match the animation duration
    };



    /*---------------Month filter-------------------*/

    const currentDate = new Date();
    const [date, setDate] = useState(new Date(currentDate.getFullYear(), currentDate.getMonth(), 1));


    /*---------------Order history-------------------*/

    const [expandedRow, setExpandedRow] = useState(null);

    const toggleExpand = (index) => {
        setExpandedRow(expandedRow === index ? null : index);
    };



    useEffect(() => {
        if (ClientId) {
            // Only the very first load should show the full-page loader; a
            // month-filter change afterwards should just refresh the table.
            const silent = !isInitialLoadRef.current;
            isInitialLoadRef.current = false;
            fetchForms(ClientId, date, { silent });
        }
    }, [ClientId, date]);

    const fetchForms = async (clientId, selectedDate, { silent = false } = {}) => {
        try {
            if (silent) {
                setIsFilterLoading(true);
            } else {
                setLoading(true);
            }

            // Extract month and year from the selectedDate
            const month = selectedDate.getMonth() + 1; // Months are 0-indexed in JS
            const year = selectedDate.getFullYear();

            const response = await apiRequest(
                `${config.apiBASEURL}/ClientFormRoutes/fetch-submitted-forms/${clientId}?month=${month}&year=${year}`,
                {
                    method: "GET",
                }
            );

            setFormsData(response.data);
        } catch (error) {
            console.error("Error fetching forms:", error);
        } finally {
            if (silent) {
                setIsFilterLoading(false);
            } else {
                setLoading(false);
            }
        }
    };




    const getSeverity = (status) => {
        switch (status) {
            case 'Draft':
                return 'primary'; // Grey
            case 'Submitted':
                return 'success'; // Blue
            case 'Work_Accepted':
                return 'success'; // Green
            case 'Work_Rejected':
                return 'danger'; // Red
            case 'Cancelled':
                return 'warning'; // Yellow
            default:
                return 'neutral';
        }
    };




    // Open edit dialog and populate form data
    const handleEditClick = (form) => {
        if (form.submission_status !== "Draft") {
            showMessage("error", "Form responses cannot be edited after submission.");
            return;
        }

        setCurrentForm(form);
        setUpdatedResponses(
            form.steps
                ? Object.values(form.steps).flatMap((sections) =>
                    Object.values(sections).flat()
                )
                : []
        );
        setShowEditModal(true);
    };

    const handleFieldChange = (form_data_id, value) => {
        setUpdatedResponses((prevResponses) =>
            prevResponses.map((field) =>
                field.form_data_id === form_data_id
                    ? {
                        ...field,
                        response: field.input_type === "date" && value instanceof Date
                            ? value.toISOString().split("T")[0] // Convert Date to "YYYY-MM-DD"
                            : value
                    }
                    : field
            )
        );
    };






    // Save form data
    const handleSave = async () => {
        if (!currentForm) return;
        setLoading(true);
        try {

            const response = await apiRequest(
                `${config.apiBASEURL}/ClientFormRoutes/form-submissions/${currentForm.form_submission_id}/form-data`,
                {
                    method: "PUT",
                    data: { responses: updatedResponses },
                }
            );
            setShowEditModal(false);
            fetchForms(ClientId, date);
        } catch (error) {
            console.error("Error updating form:", error);
            setLoading(false);

        }

    };


    const handleDownloadPDF = async (form) => {
        setLoading(true);
        try {
            const response = await apiRequest(
                `${config.apiBASEURL}/ClientFormRoutes/form-submissions-client/${form.form_submission_id}/pdf`,
                {
                    method: "GET",
                }
            );

            // ✅ Always open stored/generated URL
            window.open(response.data.pdfUrl, "_blank");
        } catch (error) {
            console.error("Error downloading PDF:", error);
        } finally {
            setLoading(false);
        }
    };




    const handleSubmitForm = async (formId) => {
        setLoading(true);
        try {
            const response = await apiRequest(
                `${config.apiBASEURL}/ClientFormRoutes/form-submissions/${formId}/submit`,
                {
                    method: "PUT",
                }
            );

            if (response.status === 200) {
                // Refresh forms after submission
                fetchForms(ClientId, date);
            }
        } catch (error) {
            console.error("Error submitting form:", error);
            setLoading(false);
        }
    };







    if (loading) {
        return <div className="loderDiv">
            <GifLoder />
        </div>;
    }



    return (
        <>
            
                <Container fluid className="pt-5 ">
                    <div className="serviceclient2">
                    {/* <Row className="pt-5 mb-3 d-flex justify-content-between align-items-center">
                        <div style={{width: '200px'}}>
                            <Breadcrumb>
                                <Breadcrumb.Item active>Select Onboarding Type</Breadcrumb.Item>
                            </Breadcrumb>
                        </div>
                        
                        
                    </Row> */}

                    <Row className="pt-5 mb-3 serviceCol pb-5">
                        <Col lg={12} md={12} className='mb-4 mb-lg-0 p-0'>
                            <div class="box-container  justify-content-center" data-onboarding="client-service-tiles">
                                <div class="box-item">
                                    <div class="flip-box">
                                        <div class="flip-box-front text-center gw-bgf">
                                            <div class="inner color-white" >
                                                <h3 class="flip-box-header">Weddings By Graphē </h3>
                                                {/* <p>Capture the magic of your special day with Graphē Wedding – where every moment is a masterpiece!</p> */}
                                                {/* <img src="https://s25.postimg.cc/65hsttv9b/cta-arrow.png" alt="" class="flip-box-img"> */}
                                                {/* <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Wedding', 'slide-left')}
                                                /> */}
                                            </div>
                                        </div>
                                        <div class="flip-box-back text-center gw-bgf2">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header"> Weddings By Graphē </h3>
                                                {/* <p>Capture the magic of your special day with Graphē Wedding – where every moment is a masterpiece!</p> */}
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Wedding', 'slide-left')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="box-item">
                                    <div class="flip-box">
                                        <div class="flip-box-front text-center gw-bgf3">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header">Website / Mobile App</h3>
                                                {/* <p>Bring your ideas to life with stunning websites and mobile apps tailored just for you!</p>
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Development', 'slide-left')}
                                                /> */}
                                            </div>
                                        </div>
                                        <div class="flip-box-back text-center gw-bgf4">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header">Website/Mobile App</h3>
                                                {/* <p>Bring your ideas to life with stunning websites and mobile apps tailored just for you!</p> */}
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Development', 'slide-left')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>

                                <div class="box-item">
                                    <div class="flip-box">
                                        <div class="flip-box-front text-center gw-bgf5">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header">Marketing</h3>
                                                {/* <p>Unlock your brand’s potential with cutting-edge marketing strategies that make an impact!</p>
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Marketing', 'slide-left')}
                                                /> */}
                                            </div>
                                        </div>
                                        <div class="flip-box-back text-center gw-bgf6">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header">Marketing</h3>
                                                {/* <p>Unlock your brand’s potential with cutting-edge marketing strategies that make an impact!</p> */}
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Marketing', 'slide-left')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>


                                <div class="box-item">
                                    <div class="flip-box">
                                        <div class="flip-box-front text-center gw-bgf7">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header">Branding</h3>
                                                {/* <p>Build a bold, memorable brand that stands out in every market</p>
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Branding', 'slide-left')}
                                                /> */}
                                            </div>
                                        </div>
                                        <div class="flip-box-back text-center gw-bgf8">
                                            <div class="inner color-white">
                                                <h3 class="flip-box-header">Branding</h3>
                                                {/* <p>Build a bold, memorable brand that stands out in every market</p> */}
                                                <Button
                                                    label="Submit Now"
                                                    icon="pi pi-arrow-right"
                                                    className="py-2 text-white"
                                                    outlined
                                                    iconPos="right"
                                                    onClick={() => handleNavigation('/Client/dashboard/Onboarding_Form/Branding', 'slide-left')}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <hr />

                    <Row className="mb-0 mt-4 pb-5 d-lg-block" data-onboarding="client-submissions">
                        <Col lg={12} className="position-relative pt-2 pb-3 d-lg-flex justify-content-between align-items-center">
                            <h6 className="text-black">Your Form Submissions
                                <small className="d-block mt-1" style={{ fontSize: '0.8rem', fontWeight: 'normal', color: '#FF5722' }}>
                                    <b>Note:</b> Please use the submit button to submit the form.
                                    {/* <i
                                    className='pi pi-info-circle text-warning custom-target-icon ms-2'
                                    data-pr-tooltip="Note: Please use the submit button to submit the form."
                                    data-pr-position="right"
                                    data-pr-at="right+5 top"
                                    data-pr-my="left center-2"
                                >
                                </i>
                                    <Tooltip target=".custom-target-icon" /> */}
                                </small>
                            </h6>
                            <div style={{ width: '300px' }} className="d-flex justify-content-lg-end align-items-center gap-2" data-onboarding="client-month-filter">
                                <label>Filter by Month</label>
                                <Calendar value={date} onChange={(e) => setDate(e.value)} view="month" dateFormat="mm/yy" style={{ width: '150px' }} />
                            </div>
                        </Col>

                        <Col lg={12} className="position-relative">
                            {isFilterLoading && (
                                <div
                                    className="d-flex justify-content-center align-items-center position-absolute w-100 h-100"
                                    style={{ top: 0, left: 0, background: "rgba(255,255,255,0.6)", zIndex: 2 }}
                                >
                                    <ProgressSpinner style={{ width: '40px', height: '40px' }} />
                                </div>
                            )}
                            <Table className="bg-white" bordered responsive>
                                <thead>
                                    <tr className="table-info">
                                        <th>#</th>
                                        <th>Form Name</th>
                                        <th>Type</th>
                                        <th>Submission Date</th>
                                        <th>Submission Status</th>
                                        <th style={{ width: "192px" }} data-onboarding="client-submission-actions">Action</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {(Array.isArray(formsData) ? formsData : []).map((form, index) => (
                                        <React.Fragment key={form.form_submission_id}>
                                            <tr>
                                                <td>{index + 1}</td>
                                                <td>{form.form_name}</td>
                                                <td>{form.type}</td>
                                                <td>{new Date(form.submission_date).toLocaleDateString('en-GB')}</td>
                                                <td className="position-relative">
                                                    <Badge
                                                        className={form.submission_status === 'Draft' ? 'example-1' : ''}
                                                        value={form.submission_status}
                                                        severity={getSeverity(form.submission_status)}
                                                    />
                                                    {form.submission_status === 'Draft' && (
                                                        <small>

                                                            <i
                                                                className='pi pi-info-circle text-danger custom-target-icon ms-2'
                                                                data-pr-tooltip="Note: Please use the submit button to submit the form."
                                                                data-pr-position="right"
                                                                data-pr-at="right+5 top"
                                                                data-pr-my="left center-2"
                                                            ></i>
                                                            <Tooltip target=".custom-target-icon" />
                                                        </small>
                                                    )}
                                                </td>
                                                <td className="d-flex justify-content-start align-items-center">
                                                    {form.submission_status === "Draft" && (
                                                        <Button
                                                            label="Submit"
                                                            severity="warning"
                                                            className="p-0 px-2"
                                                            onClick={() => handleSubmitForm(form.form_submission_id)}
                                                        />
                                                    )}
                                                    <Button
                                                        title={expandedRow === index ? "Hide" : "View"}
                                                        severity="help"
                                                        text
                                                        icon={expandedRow === index ? "pi pi-eye-slash" : "pi pi-eye"}
                                                        className="p-0 me-2"
                                                        onClick={() => toggleExpand(index)}
                                                    />
                                                    {form.submission_status === "Draft" && (
                                                        <Button
                                                            title="Edit"
                                                            severity="info"
                                                            text
                                                            icon="pi pi-pencil"
                                                            className="p-0"
                                                            onClick={() => handleEditClick(form)}
                                                        />
                                                    )}

                                                    {form.submission_status === "Submitted" && (
                                                        <Button
                                                            severity="danger"
                                                            text
                                                            icon="pi pi-file-pdf"
                                                            className="p-0 me-2"
                                                            onClick={() => handleDownloadPDF(form)}   // ✅ use new handler
                                                            tooltip="Download PDF"
                                                            tooltipOptions={{ position: 'top' }}
                                                        />
                                                    )}


                                                </td>
                                            </tr>
                                            {expandedRow === index && form.steps && typeof form.steps === "object" && (
                                                <tr className="table-light">
                                                    <td colSpan="6">
                                                        <div className="p-2 ">
                                                            <div>
                                                                {Object.entries(form.steps || {}).map(([_, sections]) => (
                                                                    sections &&
                                                                    typeof sections === "object" &&
                                                                    Object.entries(sections || {}).map(([section, fields]) => (
                                                                        <div key={section} className="allempList mt-3">
                                                                            <div className="rol-title">{section}</div>
                                                                            <ul>
                                                                                {Array.isArray(fields) &&
                                                                                    fields.map((field, i) => (
                                                                                        <li key={i}>
                                                                                            <small className="text-danger d-block">{field.field_label}</small>{" "}
                                                                                            {field.input_type === "date"
                                                                                                ? new Date(field.response).toLocaleDateString("en-GB") // Converts and formats date
                                                                                                : field.response}
                                                                                        </li>
                                                                                    ))}
                                                                            </ul>
                                                                        </div>
                                                                    ))
                                                                ))}
                                                            </div>
                                                        </div>
                                                    </td>
                                                </tr>
                                            )}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </Table>
                        </Col>
                        {/* Edit Form Modal */}
                        <Modal show={showEditModal} onHide={() => setShowEditModal(false)} backdrop="static" keyboard={false}>
                            <Modal.Header closeButton className="bg-info text-white">
                                <h5 className="mb-0">Edit Form</h5>
                            </Modal.Header>
                            <Modal.Body style={{ height: '70vh', overflowY: 'auto' }}>
                                {updatedResponses.length > 0 ? (
                                    <Form>
                                        <Row className="m-0">
                                            {updatedResponses.map((field) => (
                                                <Col lg={12} md={12} key={field.form_data_id} className="mb-2 px-1 form_edit_evnc">
                                                    <label className="form-label">{field.field_label}</label>
                                                    {/* Text Input */}
                                                    {field.input_type === "text" && (
                                                        <input
                                                            type="text"
                                                            className="form-control"
                                                            value={field.response || ""}
                                                            onChange={(e) => handleFieldChange(field.form_data_id, e.target.value)}
                                                        />
                                                    )}

                                                    {/* Date Input */}
                                                    {field.input_type === "date" && (
                                                        <input
                                                            type="date"
                                                            className="form-control"
                                                            value={
                                                                field.response && !isNaN(Date.parse(field.response))
                                                                    ? field.response.split("T")[0]
                                                                    : ""
                                                            }
                                                            onChange={(e) =>
                                                                handleFieldChange(field.form_data_id, e.target.value)
                                                            }
                                                            onClick={(e) => {
                                                                e.target.showPicker(); // Show calendar on every click
                                                            }}
                                                            onFocus={(e) => {
                                                                e.target.blur(); // Remove focus to reset behavior
                                                                setTimeout(() => e.target.focus(), 0); // Reapply focus to allow re-opening
                                                            }}
                                                        />
                                                    )}


                                                    {/* Number Input */}
                                                    {field.input_type === "number" && (
                                                        <input
                                                            type="number"
                                                            className="form-control"
                                                            value={field.response || ""}
                                                            onChange={(e) => handleFieldChange(field.form_data_id, e.target.value)}
                                                        />
                                                    )}

                                                    {/* Dropdown (Disabled) */}
                                                    {field.input_type === "select" && (
                                                        <select className="form-select" disabled>
                                                            <option value={field.response}>{field.response}</option>
                                                        </select>
                                                    )}

                                                    {/* Textarea Input */}
                                                    {field.input_type === "textarea" && (
                                                        <textarea
                                                            className="form-control"
                                                            value={field.response || ""}
                                                            onChange={(e) => handleFieldChange(field.form_data_id, e.target.value)}
                                                            rows="3"
                                                        />
                                                    )}
                                                </Col>
                                            ))}
                                        </Row>

                                    </Form>
                                ) : (
                                    <p>No fields available to edit.</p>
                                )}
                            </Modal.Body>
                            <Modal.Footer className="bg-light">
                                <Button
                                    label="Cancel"
                                    severity="secondary"
                                    className="py-2"
                                    onClick={() => setShowEditModal(false)}
                                />
                                <Button
                                    label="Update"
                                    severity="primary"
                                    className="py-2"
                                    onClick={handleSave}
                                />
                            </Modal.Footer>
                        </Modal>
                    </Row>
                    </div>
                </Container>
            
            <div className={`transition-overlay ${transition}`} />
            <CustomToast ref={toastRef} />
        </>
    );
}

export default Client_home;